var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<label class=\"sr-only\" for=\"price\">\n<span translate=\"PUBLIC_BOOKING.PRICE_FILTER.PRICE_LBL\"></span>\n</label>\n<input name=\"price\" id=\"price\" range-slider min=\"price_options.min\" max=\"price_options.max\" model-min=\"filters.price.min\" model-max=\"filters.price.max\"/>\n</div>\n";
var id1="core/price-filter/price_filter.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/price-filter/price_filter.html
// module id = 1153
// module chunks = 0